(() => {
  const closeOpenNavDropdowns = (event) => {
    document.querySelectorAll('.cf-nav-dropdown[open]').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
    });
  };

  document.addEventListener('click', closeOpenNavDropdowns);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-cf-back-to-top]').forEach((button) => {
      button.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });

    const mobileMenu = document.querySelector('.cf-mobile-menu');
    if (mobileMenu) {
      mobileMenu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => mobileMenu.removeAttribute('open'));
      });
    }
  });
})();
